module.exports = __webpack_public_path__ + "img/icon_person.a9ec1e8b.svg";